import React from 'react';
import {useAuth} from '../context/auth-context';

// Welcome / landing page for authenticated users. The actual editor mounts
// at /v1/standards/:wg/:key/:version?/:view? — that route is wired separately
// (Day 12 work, with the Standards header menu driving navigation). Until
// then, dashboard is intentionally minimal so logged-in users always have
// a working shell with avatar menu reachable.
//
// Why we don't mount <TenetEditor> here directly: editor's internal
// react-router setup expects the URL to match its own route pattern. When
// rendered at portal's `/` the inner <Switch> has nothing to match and
// downstream useRouteMatch returns null, crashing components that read
// .params on the result.

function Dashboard() {
    const {user} = useAuth();

    return (
        <div className="portal-dashboard">
            <h1 className="portal-dashboard__greeting">
                Welcome, {user.display_name || user.email}
            </h1>
            <p className="portal-dashboard__role">
                Signed in as <strong>{user.role}</strong>
                {user.workgroups && user.workgroups.length > 0 && (
                    <> — workgroups: {user.workgroups.join(', ')}</>
                )}
            </p>
            <div className="portal-dashboard__placeholder">
                Open a workgroup from the <strong>Standards</strong> menu (header) to start editing.
                The menu is being wired in the next iteration; URL form is
                <code> /v1/standards/&lt;workgroup&gt;/&lt;key&gt;/latest/overview</code>.
            </div>
        </div>
    );
}

export default Dashboard;
